<template>
    <div class="col-md-12">
        <div class="container-fluid bg-light py-3">
            <div class="h2">Routes</div>
            <div class="flash-message">
                <FlashMessage :position="'top'"></FlashMessage>
            </div>
        </div>
        <form @submit.prevent="updateRoutes">
            <div class="container-fluid bg-light py-3">
                <div v-for="(route, key_route) in routes" :key="key_route" class="row">
                    <div class="col-md-12 col-sm-12 col-lg-12">
                        <div class="p-4 mb-0 bg-white rounded-lg">
                            <div class="h3 mb-3">
                                <div class="route-name">
                                    <div
                                        class="d-flex align-items-center bg-white border rounded-lg div-focus border-2">
                                        <input autocomplete="none" required type="text"
                                               class="form-control border-0 py-0 shadow-none form-input"
                                               placeholder="name"
                                               v-model="routes[key_route].name"
                                        >
                                    </div>
                                </div>
                            </div>
                            <div
                                class="">
                                <b>is active:</b>
                                <input type="checkbox"
                                       class=""
                                       v-model="routes[key_route].is_active"
                                >
                            </div>
                            <div class="form-group mb-0">
                                <div class="form-group mb-0 row">
                                    <div class="col-md-2">
                                        <label
                                            class="d-block mb-0 font-weight-bold">Zip codes
                                        </label>
                                        <div class="pt-3">
                                            <div class="table-responsive">
                                                <table class="table table-bordered table-striped">
                                                    <thead>
                                                    <tr>
                                                        <th class="border-right text-left">
                                                            From
                                                        </th>
                                                        <th class="border-right text-center">
                                                            To
                                                        </th>
                                                        <th class="border-right text-center">
                                                            <div @click="addZipLine(key_route)"
                                                                 class="material-icons-outlined cursor-pointer mr-1"
                                                                 style="color: rgb(89, 165, 145);">
                                                                add_circle
                                                            </div>
                                                        </th>
                                                    </tr>
                                                    </thead>
                                                    <tr v-for="(zip,k) in routes[key_route].zip_codes">
                                                        <td class="border-right text-left">
                                                            <div
                                                                class="d-flex align-items-center bg-white border rounded-lg div-focus border-2">
                                                                <input autocomplete="none" required type="text"
                                                                       class="form-control border-0 py-0 shadow-none form-input"
                                                                       placeholder="zip"
                                                                       v-model="routes[key_route].zip_codes[k].from"
                                                                >
                                                            </div>
                                                        </td>
                                                        <td class="border-right text-center">
                                                            <div
                                                                class="d-flex align-items-center bg-white border rounded-lg div-focus border-2">
                                                                <input autocomplete="none" required type="text"
                                                                       class="form-control border-0 py-0 shadow-none form-input"
                                                                       placeholder="zip"
                                                                       v-model="routes[key_route].zip_codes[k].to"
                                                                >
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div @click="removeZipLine(key_route,k)"
                                                                 v-if="routes[key_route].zip_codes.length>1"
                                                                 class="material-icons-outlined cursor-pointer mr-1"
                                                                 style="color: rgb(255, 0, 0);">
                                                                remove_circle
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-md-2 service-list-hidden">
                                        <label class="d-block mb-0 font-weight-bold">Products</label>
                                        <div class="pt-3">
                                            <div v-for="item in productList">
                                                <label class="newInput">{{ item.name }}
                                                    <input
                                                        type="checkbox"
                                                        :value="item.id"
                                                        v-model="routes[key_route].products">
                                                    <span class="checkmark"></span>
                                                </label>
                                            </div>

                                        </div>
                                    </div>

                                    <div class="col-md-2 service-list-hidden">
                                        <label class="d-block mb-0 font-weight-bold">Services</label>
                                        <div class="pt-3">
                                            <div v-for="item in serviceList">
                                                <label class="newInput">{{ item.name }}
                                                    <input
                                                        type="checkbox"
                                                        :value="item.id"
                                                        v-model="routes[key_route].services">
                                                    <span class="checkmark"></span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-md-1">


                                        <label
                                            class="d-block mb-0 font-weight-bold"> Maximum volume
                                        </label>
                                        <div
                                            class="d-flex align-items-center bg-white border rounded-lg div-focus border-2">
                                            <input autocomplete="none" required type="number" min="0" step="0.01"
                                                   class="form-control border-0 py-0 shadow-none form-input"
                                                   placeholder="0"
                                                   v-model="routes[key_route].max_volume"
                                            >
                                        </div>

                                        <label
                                            class="d-block mb-0 font-weight-bold"> Maximum weight
                                        </label>
                                        <div
                                            class="d-flex align-items-center bg-white border rounded-lg div-focus border-2">
                                            <input autocomplete="none" required type="number" min="0" step="0.01"
                                                   class="form-control border-0 py-0 shadow-none form-input"
                                                   placeholder="0"
                                                   v-model="routes[key_route].max_weight"
                                            >
                                        </div>

                                        <label
                                            class="d-block mb-0 font-weight-bold"> Maximum stops
                                        </label>
                                        <div
                                            class="d-flex align-items-center bg-white border rounded-lg div-focus border-2">
                                            <input autocomplete="none" required type="number" step="1" min="0"
                                                   class="form-control border-0 py-0 shadow-none form-input"
                                                   placeholder="0"
                                                   v-model="routes[key_route].max_stops"
                                            >
                                        </div>

                                    </div>

                                    <div class="col-md-4">
                                        <label class="d-block mb-0 font-weight-bold">Days</label>
                                        <div v-for="(item,k) in daysList">
                                            <div>
                                                <label class="newInput">
                                                    {{ item.name }}
                                                    <input
                                                        type="checkbox"
                                                        :value="item.id"
                                                        v-model="routes[key_route].days">
                                                    <span class="checkmark"></span>
                                                </label>
                                            </div>

                                            <div
                                                class="d-flex align-items-center bg-white border rounded-lg div-focus border-2">
                                                <vue-timepicker
                                                    manual-input
                                                    placeholder="From"
                                                    v-model="routes[key_route].intervals[k].from"
                                                    input-class="border-0 py-0 shadow-none form-input">
                                                </vue-timepicker>

                                                -
                                                <vue-timepicker
                                                    manual-input
                                                    placeholder="To"
                                                    v-model="routes[key_route].intervals[k].to"
                                                    input-class="border-0 py-0 shadow-none form-input">
                                                </vue-timepicker>
                                                <span
                                                    class="material-icons-outlined  pr-2 text-primary">schedule</span>
                                            </div>
                                            <br/>
                                        </div>
                                    </div>

                                    <div class="col-md-1">
                                        <div class="pt-3" v-if="routes[key_route].is_existing===1">
                                            <div class="btn float-center btn-default btn-sm"
                                                 @click="deleteRoute(routes[key_route].id, routes[key_route].is_existing)">
                                                <div class="material-icons-outlined cursor-pointer text-primary"
                                                     title="remove route">delete
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div @click="addNewRouteLine"
                     title="add new route"
                     class="material-icons-outlined cursor-pointer mr-1"
                     style="color: rgb(89, 165, 145);font-size: x-large">
                    add_circle
                </div>
                <br/>
                <br/>

                <div class="row save-route" v-if="routes.length>0">
                    <div class="col-md-4">
                        <button type="submit" class="btn btn-success">
                            Save
                        </button>
                        <br/>
                        <br/>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import 'vue2-datepicker/index.css';
import 'vue2-timepicker/dist/VueTimepicker.css';
import 'vue-select/dist/vue-select.css';
import DatePicker from "vue2-datepicker";
import VueTimepicker from "vue2-timepicker";

export default {
    name: "Route",
    components: {DatePicker, VueTimepicker},
    props: {
        url: {type: String, required: true},
    },
    data() {
        return {
            routes: [],
            productList: {},
            serviceList: {},
            intervalsList: [
                {id: 1, from: '00:00', to: '00:00'},
                {id: 2, from: '00:00', to: '00:00'},
                {id: 3, from: '00:00', to: '00:00'},
                {id: 4, from: '00:00', to: '00:00'},
                {id: 5, from: '00:00', to: '00:00'},
                {id: 6, from: '00:00', to: '00:00'},
                {id: 7, from: '00:00', to: '00:00'},
            ],
            daysList: [
                {id: 1, name: 'Monday', from: '00:00', to: '00:00'},
                {id: 2, name: 'Tuesday', from: '00:00', to: '00:00'},
                {id: 3, name: 'Wednesday', from: '00:00', to: '00:00'},
                {id: 4, name: 'Thursday', from: '00:00', to: '00:00'},
                {id: 5, name: 'Friday', from: '00:00', to: '00:00'},
                {id: 6, name: 'Saturday', from: '00:00', to: '00:00'},
                {id: 7, name: 'Sunday', from: '00:00', to: '00:00'},
            ],
        }
    },
    methods: {
        fetchData() {
            axios.get('/route-list')
                .then(({data}) => {
                    Object.entries(data.data).forEach(entry => {
                        const [key, value] = entry;
                        this.routes.push({
                            name: value.name,
                            days: value.days,
                            intervals: value.intervals,
                            zip_codes: value.zip_codes,
                            products: value.productIds,
                            services: value.serviceIds,
                            max_volume: value.max_volume,
                            max_weight: value.max_weight,
                            max_stops: value.max_stops,
                            is_existing: 1,
                            id: value.id,
                            is_active: value.is_active,
                        });
                    });
                }).catch(error => this.clients = []);
            axios.get(`/product-list/0`)
                .then(({data}) => {
                    this.productList = data.data;
                }).catch()
            axios.get(`/service-list/0`)
                .then(({data}) => {
                    this.serviceList = data.data;
                }).catch()
        },
        addZipLine(key_route) {
            this.routes[key_route].zip_codes.push(
                {from: '', to: ''}
            )
        },
        removeZipLine(key_route, k) {
            this.routes[key_route].zip_codes = this.routes[key_route].zip_codes.filter((x, i) => i !== k);
        },
        addNewRouteLine() {
            this.routes.push(
                {
                    name: '',
                    days: [],
                    intervals: [
                        {id: 1, from: '00:00', to: '00:00'},
                        {id: 2, from: '00:00', to: '00:00'},
                        {id: 3, from: '00:00', to: '00:00'},
                        {id: 4, from: '00:00', to: '00:00'},
                        {id: 5, from: '00:00', to: '00:00'},
                        {id: 6, from: '00:00', to: '00:00'},
                        {id: 7, from: '00:00', to: '00:00'},
                    ],
                    products: [],
                    services: [],
                    max_volume: '',
                    max_weight: '',
                    max_stops: '',
                    zip_codes: [
                        {from: '', to: ''}
                    ],
                    is_existing: 0,
                }
            )
        },
        deleteRoute(k, is_existing) {
            if (confirm("Are you sure you want to delete this route?")) {
                this.routes = this.routes.filter((i) => i !== k);
                if (is_existing === 1) {
                    axios.delete(`/route/${k}`).then((response) => {
                        window.location.reload();
                    });
                }
            }
        },
        updateRoutes() {
            axios.post(`/my-routes`, this.routes).then((response) => {
                setTimeout(() => {
                    this.flashMessage.success({
                        title: '',
                        message: 'Routes succesfully saved',
                        time: 2000,
                        blockClass: 'flash-message'
                    });

                    //window.location.reload();
                }, 2000);
            }).catch(e => {
                console.log(e.response);
                this.flashMessage.error({
                    title: '',
                    message: e.response.data.message || 'Error',
                    time: 2000,
                    blockClass: 'flash-message error'
                });
            })
        },
    },
    created() {
        return this.fetchData();
    }
}
</script>

<style>
.service-list-hidden {
    max-height: 600px;
    overflow: scroll;
}

.route-name {
    max-width: 200px;
    margin-right: 10px;
}
</style>

